import { extraFormat, ExtraFormatReturn } from '../utilities/invoices/extra-format';
import { proFormat, ProFormatReturn } from '../utilities/invoices/pro-format';

export class InvoicesUtilityHandler {
    private _proFormat: ProFormatReturn;
    private _extraFormat: ExtraFormatReturn;

    constructor(lang = 'fr') {
        this._extraFormat = extraFormat(lang);
        this._proFormat = proFormat(lang);
    }

    get proFormat(): ProFormatReturn {
        return this._proFormat;
    }

    get extraFormat(): ExtraFormatReturn {
        return this._extraFormat;
    }
}
